import { useTranslation } from 'react-i18next'

import { postEval } from '../../../api/training'
import StatusButton from '../../StatusButton/StatusButton'

import styles from './eval.module.scss'

function Eval() {
    const { t } = useTranslation()

    return (
        <section>
            <div className={styles.eval__head}>Eval</div>
            <div className={styles.eval__content}>
                <StatusButton
                    title={t('eval')}
                    submitRequest={postEval}
                    passive
                />
            </div>
        </section>
    )
}

export default Eval
